<div class="px-4 md:px-6 lg:px-8 m-auto">
  <df-statement-public></df-statement-public>
</div>
